import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P41-E1",
    audio: "img/FriendsPlus/Page40/Audio/audio-e3-p40.mp3",
    video: "Videos/e3.p40.mp4",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page41/E1/1.jpg" }],
      [{ url: "img/FriendsPlus/Page40/E3/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page40/E3/5.jpg" },
        { url: "img/FriendsPlus/Page40/E3/6.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh1-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/7.jpg" },
        { url: "img/FriendsPlus/Page40/E3/8.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh2-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/9.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page40/E3/10.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page40/E3/11.jpg" },
        { url: "img/FriendsPlus/Page40/E3/12.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh3-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/13.jpg" },
        { url: "img/FriendsPlus/Page40/E3/14.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh4-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/15.jpg" },
      ],
      
      [{ url: "img/FriendsPlus/Page40/E3/16.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page40/E3/17.jpg" },
        { url: "img/FriendsPlus/Page40/E3/18.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh5-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/19.jpg" },
        { url: "img/FriendsPlus/Page40/E3/20.jpg", audioUrl: "img/FriendsPlus/Page40/Audio/hinh6-e3-p40.mp3", },
        { url: "img/FriendsPlus/Page40/E3/21.jpg" },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P41-E2",
    audio: "img/FriendsPlus/Page41/Audio/audio-e2-p41.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page41/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page41/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page41/Audio/tieude-e2-p41.mp3",
        },
        { url: "img/FriendsPlus/Page41/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page41/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page41/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page41/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page41/Audio/hinh1-e2-p41.mp3",
        },
        { url: "img/FriendsPlus/Page41/E2/7.jpg" },
        {
          url: "img/FriendsPlus/Page41/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page41/Audio/hinh2-e2-p41.mp3",
        },
        { url: "img/FriendsPlus/Page41/E2/9.jpg" },
        {
          url: "img/FriendsPlus/Page41/E2/10.jpg",
          audioUrl: "img/FriendsPlus/Page41/Audio/hinh3-e2-p41.mp3",
        },
        { url: "img/FriendsPlus/Page41/E2/11.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page41/E2/12.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P41-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page41/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P41-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page41/E4/Key/answerKey.png",
    inputSize: 200,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: "#44509f", num: "4", title: 'Write. Draw the time on the clock.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <img src="img/FriendsPlus/Page41/E4/title.jpg" style="width: 100%">
            <div style='display: flex; flex-direction: row;position: relative;'>
              <div style='width: 33%;margin-left: 33px;'>
                <div>He <u style='color:rgb(82,197,235)'>gets up</u> at six o'clock.</div>
              </div>
              <div style='width: 33%;margin-left: 33px;'>
                <div>He # at seven o'clock.</div>
              </div>
              <div style='width: 33%;margin-left: 33px;'>
                <div>He # at eight o'clock.</div>
              </div>
            </div>
          </div>
        `,
        answer: ["has breakfast", "goes to school"],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P41-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page41/E5/1.jpg" }]],
  },
};

export default json;
